import { splitLines } from '../detect.js';
export const parseMindmap = (source) => {
    const lines = splitLines(source);
    const nodes = new Map();
    const idCounter = { i: 0 };
    for (const raw of lines) {
        if (!raw.trim() || /^mindmap\b/i.test(raw.trim()))
            continue;
        const indent = raw.match(/^\s*/)?.[0].length ?? 0;
        const label = raw.trim();
        if (!label)
            continue;
        const level = Math.floor(indent / 2);
        const id = `m_${idCounter.i++}`;
        let parent;
        for (let l = level - 1; l >= 0; l--) {
            const candidate = Array.from(nodes.values()).find((n) => n.level === l);
            if (candidate) {
                parent = candidate.id;
                break;
            }
        }
        nodes.set(id, { id, label, level, parent });
    }
    const finalNodes = Array.from(nodes.values()).map((n) => ({
        id: n.id,
        label: n.label,
        shape: 'rect',
        parent: n.parent,
    }));
    return {
        type: 'mindmap',
        nodes: finalNodes,
        edges: [],
        groups: [],
        styles: {},
        meta: {},
    };
};
//# sourceMappingURL=mindmap.js.map